import React from "react"
import { Route, Redirect } from "react-router-dom"
import { isLoggedIn } from "../util/jwt_utils"
import { setPageTitle } from "../util/title_utils"
import { generateRedirectPath } from "../util/router_utils"

export function PrivateRoute({
    component: Component,
    passProps,
    onboardingStep,
    ...rest
}) {
    const { title, computedMatch, name, open, allowRedirect } = rest
    const {
        handleSetRedirect,
        handleClearRedirect,
        navigationState,
    } = passProps
    const loggedIn = isLoggedIn()
    setPageTitle(title || "Shoutbase", computedMatch)
    const redirectPath = generateRedirectPath(
        loggedIn,
        onboardingStep,
        name,
        open,
    )
    const { redirect } = navigationState

    if (!loggedIn && !open && allowRedirect) {
        handleSetRedirect({
            redirect: name,
            location: rest.location,
        })
    } else {
        if (name === redirect) {
            rest.location = navigationState.location
            handleClearRedirect()
        }
    }
    return (
        <Route
            {...rest}
            render={props =>
                redirectPath ? (
                    <Redirect
                        to={{
                            pathname: redirectPath,
                            state: { from: props.location },
                        }}
                    />
                ) : (
                    <Component {...props} {...passProps} route={rest} />
                )
            }
        />
    )
}



// WEBPACK FOOTER //
// ./src/components/private_route.jsx